// Core
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import {
  deleteOfferCode,
  editOfferCodeListStatus,
  fetchOfferCodeList,
} from "../../../Redux/Slices/contentManagementSlice";

// Custom layout
import MainLayout from "../../../Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../Assets";

//utils
import { notifySuccess } from "Services/Utils/toastNotification";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import Modal from "Components/Common/Modal";
const OfferCodes = () => {
  const headerDetails = [
    {
      label: "Offer Codes",
      sortKey: false,
    },
    {
      label: "No.of Credits Avail",
      sortKey: false,
    },
    {
      label: "Valid from",
      sortKey: false,
    },
    {
      label: "Valid till",
      sortKey: false,
    },
    {
      label: "Status",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "status",
        });
      },
    },
  ];

  //should change the state values during API integration, currently using staff module code for sample
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rowsPerPage = 10;
  const [offerCode, setOfferCode] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [sortOptions, setSortOptions] = useState({
    sort_by:"",
    order_by: "createdAt",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [offerToDelete, setOfferToDelete] = useState(null);
  // to trigger rerender after status change
  const [staffStatus, setStaffStatus] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
    // console.log(openMenuId)
  };

  const handleOutsideClick = (e) => {
    // Check if clicked outside and if the menu is open
    if (openMenuId !== null && !e.target.closest(".optionsMenu")) {
      setOpenMenuId(null); // Close the menu if clicked outside
    }
  };

  //to be used for API Calls

  const changeStatus = (status, id) => {
    console.log(status, id);
    if (status === 2) {
      status = 3;
    } else {
      status = 2;
    }
    dispatch(
      editOfferCodeListStatus({
        data: {
          status: status,
          id: id,
        },
        callBack: offerCodeStatusChangeCB,
      })
    );
  };

  const deleteIndividualOfferCode = () => {
    if (offerToDelete) {
    dispatch(
      deleteOfferCode({
        data: {
          id: offerToDelete,
        },
        callBack: deleteOfferCodeCB,
      })
    );
  }
    setIsModalOpen(false);
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      fetchOfferCodeList({
        data: {
          search: search,
          page: search ? 1 : currentPage,
          limit: rowsPerPage,
          sort_by: sortOptions.sort_by ? "ASC" : "DESC",
          order_by: sortOptions.order_by,
        },
        callBack: offerCodeCB,
      })
    );
  }, [sortOptions, currentPage, search, staffStatus]);

  const offerCodeCB = (value) => {
    setOfferCode(value.data.data_list);
    setTotalPage(value.data.pageMeta.totalPages);
    setIsLoading(false);
  };

  const offerCodeStatusChangeCB = (value) => {
    //triggers rerender after status change
    setStaffStatus(!staffStatus);
    //closes the options menu
    setOpenMenuId(null);
  };

  const openDeleteConfirmationModal = (productId) => {
    setOfferToDelete(productId);
    setIsModalOpen(true);
    setOpenMenuId(null)
  };

  const deleteOfferCodeCB = (value) => {
    console.log(value);
    notifySuccess("Offer Code Deleted Successfully");
    //triggers rerender after status change
    setStaffStatus(!staffStatus);
    //closes the options menu
    setOpenMenuId(null);
  };

  useEffect(() => {
    // Add the event listener with a slight delay to allow the toggleMenu logic to complete
    const timer = setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 0);

    // Clean up event listener on unmount or when the component re-renders
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openMenuId]);

  return (
    <div className="offerCodeContainer">
      <div className="offerCodeHeader">
        <div className="offerCodeHeading">Offer Codes</div>
        <div className="offerCodeSearch">
          <div>
            <InputBox
              value={search}
              icon={assets.Icons.searchIcon}
              onChange={(e) => setSearch(e.target.value)}
              inputStyle={{
                padding: "1px 2vh 1px 7vh",
                border: "none",
                height: "43px",
                width: "25vw",
                borderRadius: "0px",
                borderBottom: "1px solid #C1C7CD",
                boxShadow: "none",
                color: "black",
              }}
            />
          </div>
        <div
          className="offerCodeButton"
          onClick={() => navigate("/contentManagement/addOfferCode")}
        >
          <Button buttonStyle={{ height: "1vh" }} title="Add New" />
        </div>
        </div>
      </div>
      <div className="offerCodeTable">
        <NormalTable
          headerDetails={headerDetails}
          // pagination={true}
        >
          {offerCode.length > 0
            ? offerCode.map((list) => {
                return (
                  <>
                    <tr
                      key={list.offer_code_id}
                      className="border"
                      style={{ position: "relative" }}
                    >
                      <td>{list.offer_code}</td>
                      <td>{list.number_of_credits_available}</td>
                      <td>
                        {new Date(list.start_date).toLocaleDateString("en-GB")}
                      </td>
                      <td>
                        {new Date(list.end_date).toLocaleDateString("en-GB")}
                      </td>
                      <td
                        style={{
                          color: `${list.status === 2 ? "#10CA23" : "#FF482F"}`,
                        }}
                      >
                        {list.status === 2 ? "Active" : "In Active"}
                      </td>
                      <td>
                        <img
                          style={{ height: "15px", cursor: "pointer" }}
                          src={assets.Icons.optionsIcon}
                          alt="Options"
                          onClick={() => toggleMenu(list.offer_code_id)} // Open menu for this row
                        />
                        {openMenuId === list.offer_code_id && (
                          <div className="optionsMenu">
                            <ul>
                              <li
                                onClick={() =>
                                  navigate(
                                    `/contentManagement/viewOfferCode/${list.offer_code_id}`
                                  )
                                }
                              >
                                <img src={assets.Icons.viewIcon} alt="" />
                                View
                              </li>
                              <li
                                onClick={() =>
                                  navigate(
                                    `/contentManagement/editOfferCode/${list.offer_code_id}`
                                  )
                                }
                              >
                                <img src={assets.Icons.editIcon} alt="" />
                                Edit
                              </li>
                              <li
                                onClick={() =>
                                  openDeleteConfirmationModal(list.offer_code_id)
                                }
                              >
                                <img src={assets.Icons.deleteIcon} alt="" />
                                Delete
                              </li>
                              <li
                                onClick={() =>
                                  changeStatus(list.status, list.offer_code_id)
                                }
                              >
                                <img
                                  src={assets.Icons.activeInactiveIcon}
                                  alt=""
                                />
                                Mark as{" "}
                                {list.status === 2 ? "Inactive" : "Active"}
                              </li>
                            </ul>
                          </div>
                        )}
                      </td>
                    </tr>
                  </>
                );
              })
              : isLoading ? "Loading..." : "No Data"}
        </NormalTable> 
        <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
              <h3 style={{ textAlign:'center', fontFamily:'Roboto' }}>Are you sure you want to delete this OfferCode?</h3>
            <div style={{ display:'flex', flexDirection:'row', justifyContent:'space-around', paddingTop:'20px' }}>
              <Button
              buttonStyle={{
                width: "40%",
                height: "2vh",
              }}
               title='Delete'
               onClick={deleteIndividualOfferCode}
              />
              <Button
                  buttonStyle={{
                    height: "2vh",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid black",
                    width: "40%",
                  }}
                  titleStlye={{ color: "#888888" }}
                  title="Cancel"
                  onClick={() => setIsModalOpen(false)}
                />
            </div>
          </Modal>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPage}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default OfferCodes;
